/*
 * Label component
 */
import React from 'react';

import Base from './base.jsx'; 
import {
  castDataType,
  DataType
} from '../common.jsx';
import Setting from "./setting.jsx";


export default class Label extends Base {

        static get ANSWER_DEPENDENT() {
          return false
        }

        static get CATEGORY() {
            return 'other';
        }

        static get TYPE() {
            return 'label_text';
        }

        static icon(){
            return <i className="fa fa-tag"></i>;
        }

        static get TRANSLATED_ATTRIBUTES() {
            return {
                text: 'label_default_text',
                description: 'field_default_description'
            };
        }

        static defaultContent(language) {
            return Object.assign(super.defaultContent(language), {
                text: 'text',
                description: 'description',
                guideline: false,
            });
        }

        renderView() {
            return (
                <div>
                    <label>{this.getText('text')}</label>
                    {this.descriptionText()}
                </div>
            );
        }

        renderPrettyView() {
            // Don't need pretty config because it can toggle by guideline
            return (!this.props.content.guideline ?
                <div>
                    <label>{this.getText('text')}</label>
                </div>
             : null);
        }

        renderSettings() {
            return (
                <div>
                    <Setting.LongTextField name="text" label={I18n.t('field_text', {scope: 'fe'})} value={this.getText('text')} onChange={this.updateSettings} onKeyPress={this.preventEnterSubmit} />
                    <Setting.LongTextField name="description" label={I18n.t('field_description', {scope: 'fe'})} value={this.getText('description')} onChange={this.updateSettings} />
                    <Setting.Checkbox name="guideline" label={I18n.t('guideline', {scope: 'fe'})} value={this.props.content.guideline} onChange={this.updateSettings} />    
                </div>
            );
        }

        beforeUpdateSettings(content) {
            content.guideline = castDataType(content.guideline, DataType.BOOLEAN);
        }
}
